<template>
  <v-btn-toggle tile group v-model="emailDivider" mandatory>
    <v-btn small value="comma"> Komma </v-btn>
    <v-btn small value="semicolon"> Semikolon </v-btn>
  </v-btn-toggle>
</template>
<script>
import { defineComponent } from "vue";
import { getEmailDivider, setEmailDivider } from "@/services/settings.service";
import { updateEmailDivider } from "@/services/bus.service";
export default defineComponent({
  name: "EmailDivider",
  data() {
    return {
      emailDivider: "",
    };
  },
  watch: {
    emailDivider() {
      setEmailDivider(this.emailDivider);
      updateEmailDivider(this.emailDivider);
    },
  },
  created() {
    this.emailDivider = getEmailDivider();
  },
});
</script>
